import * as React from "react";
import { IconName as newIconName } from "@skbkontur/icons/internal/Icon";
import {
    Toggle,
    Button,
    Center,
    Checkbox,
    DatePicker as BaseDatePicker,
    Dropdown,
    DropdownMenu,
    Group,
    Hint,
    HintProps,
    Input,
    MaskedInput,
    Kebab,
    Link,
    MenuHeader,
    MenuItem,
    MenuSeparator,
    Modal,
    MiniModal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Radio,
    RadioGroup,
    ScrollContainer,
    Select,
    Sticky,
    Tabs,
    Textarea,
    ThemeContext,
    Toast,
    Tooltip,
    TooltipTrigger,
    Autocomplete,
    SidePage,
    ThemeFactory,
    Paging,
    LIGHT_THEME as DEFAULT_THEME,
    Loader,
    Spinner,
    LIGHT_THEME_5_0 as LIGHT_THEME,
    DARK_THEME_5_0 as DARK_THEME,
} from "@skbkontur/react-ui";
import { ComboBox } from "@skbkontur/react-ui/components/ComboBox";
import { DatePickerProps } from "@skbkontur/react-ui/components/DatePicker";
import type { ButtonType, ButtonUse } from "@skbkontur/react-ui/components/Button/Button";
import type { InputAlign, InputProps } from "@skbkontur/react-ui/components/Input";
import { Popup } from "@skbkontur/react-ui/internal/Popup";
import type { PopupPositionsType } from "@skbkontur/react-ui/internal/Popup";
import { SizeProp } from "@skbkontur/react-ui/lib/types/props";
import { getScrollWidth } from "@skbkontur/react-ui/lib/dom/getScrollWidth";
import * as Keyboard from "@skbkontur/react-ui/lib/events/keyboard/identifiers";
import { Nullable } from "@skbkontur/react-ui/typings/utility-types";
import type { Theme } from "@skbkontur/react-ui/lib/theming/Theme";
import { RenderLayer } from "@skbkontur/react-ui/internal/RenderLayer";
import { ZIndex } from "@skbkontur/react-ui/internal/ZIndex";

import { isTestingMode } from "../../Testing";

import { CurrencyInput } from "./CustomControls/CurrencyInput/CurrencyInput";
import { FxInput } from "./CustomControls/FxInput/FxInput";
import { Gapped } from "./CustomControls/Gapped/Gapped";
import { Kladr } from "./CustomControls/Kladr/Kladr";
import type { KladrValue } from "./CustomControls/Kladr/Kladr";
import { Address } from "./CustomControls/Kladr/Types";

type ButtonArrow = boolean | "left";
export type AllIconNames = newIconName;

export type { ButtonArrow, SizeProp as ButtonSize, ButtonType, ButtonUse, PopupPositionsType, TooltipTrigger };
export { Button };
export { Link };
export { Center };
export { Checkbox };
export { ComboBox };
export { CurrencyInput };
export { Dropdown };
export { DropdownMenu };
export { FxInput };
export { Gapped };
export { getScrollWidth };
export { Hint };
export type { HintProps };
export type { InputAlign, InputProps };
export { Input };
export { Kebab };
export type { KladrValue, Address };
export { Kladr };
export { Loader };
export { MaskedInput };
export { MenuItem };
export { MenuSeparator, MenuHeader };
export { Modal, MiniModal, ModalHeader, ModalBody, ModalFooter };
export { Popup };
export { Radio };
export { RadioGroup };
export { RenderLayer };
export { ScrollContainer };
export { Select };
export { Spinner };
export { Sticky };
export { Tabs };
export { Textarea };
export { ThemeContext };
export { ThemeFactory };
export { DEFAULT_THEME };
export { Toast };
export type { Theme };
export { Keyboard };
export { ZIndex };
export { Group };
export { Autocomplete };
export { Paging };
export { SidePage };
export { Toggle };
export { LIGHT_THEME, DARK_THEME };

export interface CandyTooltipProps {
    hideForTests?: boolean;
    width?: string | number;
    anchorElement?: HTMLElement;
    children?: React.ReactNode;
    className?: string;
    closeButton?: boolean;
    render?: Nullable<() => React.ReactNode>;
    pos?: PopupPositionsType;
    trigger?: TooltipTrigger;
    onCloseClick?: React.MouseEventHandler<HTMLElement>;
    onCloseRequest?: () => void;
    allowedPositions?: PopupPositionsType[];
    disableAnimations?: boolean;
    useWrapper?: boolean;
}

// Если понадобиться подчеркивать ссылки, то вот кодец как это сделать
// export const Link = React.forwardRef((props: LinkProps, ref: React.ForwardedRef<ReactUiLink>) => (
//     <HoverFix use={props.use}>
//         <ReactUiLink {...props} ref={ref}>
//             {props.children}
//         </ReactUiLink>
//     </HoverFix>
// ));
// Link.displayName = "Link";

export class CandyTooltip extends React.Component<CandyTooltipProps> {
    public render(): JSX.Element {
        if (isTestingMode() && this.props.hideForTests) {
            return <Tooltip {...this.props} trigger="closed" disableAnimations data-tid="tooltip" />;
        } else {
            return <Tooltip {...this.props} />;
        }
    }
}

export class DatePicker extends React.Component<JSX.LibraryManagedAttributes<typeof BaseDatePicker, DatePickerProps>> {
    private datePicker?: null | BaseDatePicker;

    public focus(): void {
        this.datePicker?.focus();
    }

    public onFocus = (): void => {
        if (this.props.onFocus) {
            this.props.onFocus();
        }

        if (isTestingMode() && this.datePicker != undefined) {
            this.datePicker.close();
        }
    };

    public render(): React.ReactNode {
        return (
            <BaseDatePicker
                {...this.props}
                // @ts-ignore иначе виджет подыхает при сборке - не может сопоставить типы библиотек одинаковых версий
                renderDay={this.props.renderDay}
                width={this.props.width ?? 120}
                ref={x => (this.datePicker = x)}
                onFocus={this.onFocus}
            />
        );
    }
}
